/* ═══════════════════════════════════════════
   TAKEN — theme behaviours
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var reduceMotion = document.documentElement.classList.contains('reduce-motion');

  /* ── Scroll reveal ── */
  function initReveal() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;
    if (!reduceMotion && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (r) { io.observe(r); });
    } else {
      reveals.forEach(function (r) { r.classList.add('is-visible'); });
    }
  }

  /* ── Variant picker ──
     Wires a set of [data-variant-picker] swatches to a product form.
     Each swatch carries data-variant-id / data-image / data-price /
     data-available. Reads variant data from a JSON script tag so it
     stays in sync with real Shopify inventory & pricing.            */
  function initVariantPickers() {
    var roots = document.querySelectorAll('[data-product-root]');
    roots.forEach(function (root) {
      var swatches = root.querySelectorAll('[data-variant-picker] .swatch');
      var image = root.querySelector('[data-variant-image]');
      var priceEl = root.querySelector('[data-variant-price]');
      var idInput = root.querySelector('[data-variant-id]');
      var addBtn = root.querySelector('[data-add-button]');
      var addLabel = root.querySelector('[data-add-label]');
      if (!swatches.length) return;

      function select(btn) {
        swatches.forEach(function (s) {
          s.classList.remove('swatch--active');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('swatch--active');
        btn.setAttribute('aria-pressed', 'true');

        var name = btn.getAttribute('data-name') || '';
        var img = btn.getAttribute('data-image');
        var price = btn.getAttribute('data-price');
        var available = btn.getAttribute('data-available') !== 'false';
        var vid = btn.getAttribute('data-variant-id');

        if (image && img) {
          var apply = function () {
            image.src = img;
            image.alt = image.getAttribute('data-alt-base') || image.alt;
            if (name) image.alt = (image.getAttribute('data-alt-base') || 'TAKEN bracelet') + ' — ' + name.toLowerCase();
            image.style.opacity = '1';
          };
          if (reduceMotion) { apply(); }
          else { image.style.opacity = '0'; setTimeout(apply, 200); }
        }
        if (idInput && vid) idInput.value = vid;
        if (priceEl && price) priceEl.innerHTML = price;
        if (addBtn) {
          addBtn.disabled = !available;
          if (addLabel) {
            addLabel.textContent = available
              ? (addBtn.getAttribute('data-label-add') || 'Add to cart')
              : (addBtn.getAttribute('data-label-sold') || 'Sold out');
          }
        }
      }

      swatches.forEach(function (s) {
        s.addEventListener('click', function () { select(s); });
      });
    });
  }

  /* ── Newsletter (Shopify customer form) enhancement ──
     Shopify posts the form; we just surface inline validation nicely. */
  function initNewsletter() {
    var forms = document.querySelectorAll('[data-newsletter-form]');
    forms.forEach(function (nf) {
      nf.addEventListener('submit', function (e) {
        var email = nf.querySelector('input[type="email"]');
        var note = nf.querySelector('[data-newsletter-note]');
        if (email && (!email.value || email.validity.typeMismatch || email.value.indexOf('@') === -1)) {
          e.preventDefault();
          if (note) note.textContent = 'Please enter a valid email address.';
          email.focus();
        }
      });
    });
  }

  /* ── Mobile navigation toggle ── */
  function initMobileNav() {
    var nav = document.querySelector('.site-nav');
    if (!nav) return;
    var toggle = nav.querySelector('.nav__toggle');
    if (!toggle) return;

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });

    /* Close when a menu link is tapped */
    nav.querySelectorAll('.nav__links a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });

    /* Close on Escape or when tapping outside the header */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target)) setOpen(false);
    });
  }

  /* ── Image lightbox ── */
  function initLightbox() {
    var triggers = document.querySelectorAll('[data-lightbox]');
    if (!triggers.length) return;

    var overlay, imgEl, capEl, lastFocus;

    function build() {
      overlay = document.createElement('div');
      overlay.className = 'lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.innerHTML =
        '<button type="button" class="lightbox__close" aria-label="Close">×</button>' +
        '<figure class="lightbox__figure">' +
          '<img class="lightbox__img" alt="">' +
          '<figcaption class="lightbox__caption"></figcaption>' +
        '</figure>';
      document.body.appendChild(overlay);
      imgEl = overlay.querySelector('.lightbox__img');
      capEl = overlay.querySelector('.lightbox__caption');

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target.classList.contains('lightbox__close')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
      });
    }

    function open(src, caption) {
      if (!overlay) build();
      lastFocus = document.activeElement;
      imgEl.src = src;
      imgEl.alt = caption || '';
      capEl.textContent = caption || '';
      capEl.style.display = caption ? '' : 'none';
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      overlay.querySelector('.lightbox__close').focus();
    }

    function close() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    triggers.forEach(function (el) {
      el.addEventListener('click', function () {
        open(el.getAttribute('data-full') || el.getAttribute('src'),
             el.getAttribute('data-caption') || el.getAttribute('alt') || '');
      });
    });
  }

  function init() {
    initReveal();
    initVariantPickers();
    initNewsletter();
    initMobileNav();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when sections are re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
